import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var dashboardSOListRes;
export const dashboardSOListTodo = createAsyncThunk('dashboardSOList', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_so_list',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vtype": localStorage.getItem('cTax_type'),
                "vcustomer_code": localStorage.getItem('vcust_plant_code'),
                "vpo_code": "",
                "pageing": "1",
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vfin_year": localStorage.getItem('vfin_year'),
                "vfrom_date": "",
                "vto_date": "",
                "vdespatch_status": "F"

            }
        })
        return dashboardSOListRes = res.data

    } catch (error) {
        return dashboardSOListRes = error.response.data
    }
});

const dashboardSOListSlice = createSlice({
    name: 'dashboardSOList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardSOListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(dashboardSOListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default dashboardSOListSlice.reducer; 